import { ApiRoutesInterface } from '@plugin/Common/interfaces/cross-sell/api-routes.interface'

const apiRoutesConstants: ApiRoutesInterface = {
  basePath: '/api/cross-sell',
  getForCart: 'cart',
  getForProduct: (productId: number) => `product/${productId}`,
  getSettingsForProduct: (productId: number) => `product/${productId}/settings`,
}

export { apiRoutesConstants }
